import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { DomainService } from './domain.service';
import { JobsService } from './jobs.service';

@Injectable({
  providedIn: 'root'
})
export class ReadyIntervalService {
  private readyInterval: BehaviorSubject<number> = new BehaviorSubject(300);
  readyInterval$ = this.readyInterval.asObservable();

  constructor(
    private authService: AuthService,
    private domainService: DomainService,
    private jobsService: JobsService
  ) {
    this.subscribeToReadyIntervals();
  }

  getReadyInterval() {
    return this.readyInterval.value;
  }

  subscribeToReadyIntervals() {
    combineLatest([
      this.authService.agent$,
      this.domainService.domain,
      this.domainService.defaultDomain,
      this.jobsService.currentJob$
    ])
      .pipe(
        map(([agent, domain, defaultDomain, job]) => {
          // If the job doc specifies a ready_interval, it always wins
          if (job?.ready_interval != null) {
            return job.ready_interval;
          }

          // GLOBAL agents: use only their domain doc's ready_interval
          if (agent?.aid === 'GLOBAL') {
            return domain?.ready_interval ?? 20;
          }

          // Regular agents: use the max of account domain and default domain
          const domainInterval = domain?.ready_interval ?? 20;
          const defaultInterval = defaultDomain?.ready_interval ?? 20;
          return Math.max(domainInterval, defaultInterval);
        }),
        distinctUntilChanged()
      )
      .subscribe(interval => this.readyInterval.next(interval));
  }
}
